import React, { useContext } from 'react';
import { SettingsContext } from '../providers/SettingsProvider';
import styles from './Settings.module.scss';
import useLocalize from '../hooks/use-localize';

const Settings = () => {
  const { localize } = useLocalize();
  const { areDetailsVisible = false, isCrustEnabled = false, handleCrustChange = undefined, handleDetailModeChange = undefined } = useContext(SettingsContext);

  return (
    <div className={styles.settings}>
      <label htmlFor='crust'>
        <input checked={isCrustEnabled} id='crust' onChange={handleCrustChange} type='checkbox' />
        <span>{localize('settings.dessert_with_dough')}</span>
      </label>
      <label htmlFor='detailMode'>
        <input checked={areDetailsVisible} id='detailMode' onChange={handleDetailModeChange} type='checkbox' />
        <span>{localize('settings.show_details')}</span>
      </label>
    </div>
  );
};

export default Settings;
